/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar-info-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>event date time appointment</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M17.25 11.25a6 6 0 100 12 6 6 0 100-12zM17.25 20.25v-3"/><path pid="1" d="M17.25 14.25h-.01c-.21 0-.38.16-.38.37 0 .2.16.37.37.37.2-.01.37-.17.37-.38v0c0-.21-.17-.375-.375-.375v0M8.25 17.25H2.24a1.51 1.51 0 01-1.5-1.5v-12h0c-.01-.83.67-1.51 1.49-1.51h13.5-.01c.82-.01 1.5.67 1.5 1.5v4.48"/></g><g stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="2" d="M.75 6.75h16.5"/><g stroke-linecap="round"><path pid="3" d="M5.24 3.75v-3M12.74 3.75v-3"/></g></g>'
  }
})
